import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';
import { Toast, ImageUploader } from 'antd-mobile'
import { ImageUploadItem } from 'antd-mobile/es/components/image-uploader'
import { uploadFile } from "@service/commonService";
import camera from '@src/assets/image/icon/camera.png'
import { Swiper, SwiperSlide } from 'swiper/react';
import { isIOS, base64ToBlob } from '@src/util'
import uuid from 'uuidjs'
import 'swiper/swiper-bundle.css'
type OssItemType = {
  id: number
  osskey: string
  osskeySmall: string
}
type UploadImg = {
  children?: any
  hint?: string
  maxCount: number
  value?: []
  onChange?: any
}

type showProps = {
  list: Array<any>;
  onClose: () => void;
  onDelete: (T: any) => void;
};

const Modal: React.FC<showProps> = (props) => {
  const { list, onClose, onDelete } = props;
  const doc = document.body;
  return ReactDOM.createPortal(
    <div className="img-ck-mask" onTouchMove={(e) => { e.stopPropagation() }}>
      <div className="upload-mask" onTouchMove={(e) => { e.stopPropagation() }}>
        <Swiper autoplay allowTouchMove>
          {list.map((res: any, index: number) => <SwiperSlide key={index}>
            <div className="zgnr" onClick={() => { onClose() }}>
              <i className="delete" onClick={(e) => {
                onDelete(index)
                e.stopPropagation()
              }}></i>
              <div>{index + 1}/{list.length}</div>
              <img src={res.url} alt=""></img>
            </div>
          </SwiperSlide>)}
        </Swiper>
      </div>
    </div>,
    doc
  );
};

export default function (props: UploadImg) {
  const [fileList, setFileList] = useState<ImageUploadItem[]>([])
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    if (props.value) {
      props.value && setFileList(props.value)
    } else {
      setFileList([])
    }
  }, [props.value])
  // 上传
  const upload = async (file: File) => {
    Toast.show({
      icon: 'loading',
      content: '图片上传中…',
      duration: 0,
      maskClickable: false
    })
    let urlList: any = {
      url: URL.createObjectURL(file)
    }
    await uploadFile(file).then((rs: OssItemType) => {
      urlList = {
        id: rs.id,
        url: URL.createObjectURL(file)
      }
      Toast.clear()
    }).catch(() => {
      Toast.show('图片上传失败，请重新上传！')
      setTimeout(() => {
        setFileList(fileList.filter((res: any) => res.id))
      }, 500);
    })
    return urlList
  }

  const onChange = (file: ImageUploadItem[]) => {
    setFileList(file)
    props.onChange && props.onChange((file.filter((res: any) => res.id)))
  }
  const showPreview = () => {
    setVisible(true)
  }
  // 上传
  const upload2 = async (file: Blob) => {
    Toast.show({
      icon: 'loading',
      content: '图片上传中…',
      duration: 0,
      maskClickable: false
    })
    const uid = uuid.generate()
    let urlList: any = {
      uid
    }
    const Imglist = JSON.parse(JSON.stringify([...fileList, urlList]))
    await uploadFile(file).then((rs: OssItemType) => {
      urlList = {
        id: rs.id,
        url: rs.osskey
      }
      let indent = 0
      const ony = Imglist.find((res: any, index: number) => {
        if (res.uid == uid) {
          indent = index
        }
        return res.uid == uid
      })
      const list: Array<any> = JSON.parse(JSON.stringify(Imglist))
      if (ony) {
        list[indent] = urlList
      }
      setFileList(list)
      props.onChange && props.onChange((list.filter((res: any) => res.id)))
      Toast.clear()
    }).catch(() => {
      Toast.show('图片上传失败，请重新上传！')
      setTimeout(() => {
        setFileList(fileList.filter((res: any) => res.id))
      }, 500);
    })
  }
  const judgeIsIosJs = (e: any) => {
    try {
      if ((e.target.className === 'camera' && e.target.localName === 'img' || e.target.localName == 'div') && isIOS) {
        // 当使用ios系统时特殊处理
        // Toast.show({
        //   icon: 'loading',
        //   content: '图片上传中…',
        //   duration: 0,
        //   maskClickable: false
        // })
        try {
          const win: any = window;
          win['iosAlbum'] = function (data: any) {
            // Toast.clear()
            const fileBlob = base64ToBlob(data, 'tp')
            upload2(fileBlob)
            win['iosAlbum'] = undefined
          }
          win.webkit.messageHandlers.photoAlbumAction.postMessage({});
        } catch (e) {
          console.log(e)
          Toast.show('图片处理失败')
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  return <div onClick={judgeIsIosJs}><ImageUploader
    value={fileList}
    disableUpload={isIOS}
    onChange={onChange}
    upload={upload}
    multiple={props.maxCount > 1 ? true : false}
    preview={false}
    imageFit={'cover'}
    maxCount={props.maxCount}
    onPreview={showPreview}
    showUpload={fileList.length < props.maxCount}
    onCountExceed={exceed => { Toast.show(`最多选择 ${props.maxCount} 张图片，您多选了 ${exceed} 张`) }}>
    <div className='img-box'>
      <img className='camera' alt='' src={camera}></img>
      {props.hint && <div className='hint'>{props.hint}</div>}
    </div>
  </ImageUploader>
    {visible && <Modal list={fileList} onClose={() => { setVisible(false) }} onDelete={(e) => {
      const list = JSON.parse(JSON.stringify(fileList))
      list.splice(e, 1)
      props.onChange && props.onChange(list)
      setFileList(list)
      if (!list.length) {
        setVisible(false)
      }
    }}></Modal>}
  </div>
}
